export default __webpack_public_path__ + "static/media/client3.c236b036.png";